import React, {useMemo} from 'react';

import {Autocomplete, Select} from '@zoom/react-ui';
import {useTranslation} from 'react-i18next';

import {ZmTextField} from 'Components/ZmInputs';
import {COUNTRY_DATA} from 'Utils/phoneCountryCodes';

/**
 * Country Code Input Component
 * @param {Object} props
 * @return {ReactElement}
 */
export default function CountryInput(props) {
  const {
    error,
    hideLabel,
    id,
    onChange,
    sx = {},
    value,
  } = props;
  const {t} = useTranslation();

  // Get the option item with value corresponding to the value string
  const autocompleteValue = useMemo(() => {
    if (value) {
      return COUNTRY_DATA.find((opt) => opt.phone === value) || null;
    }
    return null;
  }, [value]);

  const filterOptions = (options, {inputValue}) => {
    return options.filter((option) => {
      // eslint-disable-next-line max-len
      return option.label.toLowerCase().includes(inputValue.toLowerCase()) || option.phone.toLowerCase().includes(inputValue.toLowerCase());
    });
  };

  return (
    <Autocomplete
      componentsProps={{
        paper: {
          sx: {
            width: 'fit-content',
          },
        },
      }}
      id={`ac-${id}`}
      disableClearable={true}
      options={COUNTRY_DATA}
      value={autocompleteValue}
      autoHighlight
      filterOptions={filterOptions}
      clearIcon={null}
      getOptionLabel={(option) => `${option.phone.split('-')[0]}`}
      renderOption={(props, option, state) => (
        <Select.Option
          {...props}
          key={option.label}
          selected={state.selected}
        >
          {option.label} ({option.phone})
        </Select.Option>
      )}
      onChange={(e, value, reason) => onChange(value.phone)}
      renderInput={(params) => (
        <ZmTextField
          role="listbox"
          margin="dense"
          fullWidth
          variant="outlined"
          aria-required
          label={hideLabel? undefined: t('booking.phoneCountryCode')}
          id={id}
          {...params}
          placeholder={'Country/Region code'}
          sx={{
            ...((sx.marginTop !== undefined)? {marginTop: sx.marginTop}: {}),
            '.MuiInputBase-root.MuiOutlinedInput-root': {
              alignContent: 'center',
              paddingRight: '30px',
              ...(sx.height? {height: sx.height}: {}),
            },
            '& label': {
              textWrap: 'nowrap',
            },
          }}
          inputProps={{
            ...params.inputProps,
            autoComplete: 'tel-country-code',
            minLength: 2,
            maxLength: 6,
            style: {
              textAlign: sx.textAlign || 'right',
            },
          }}
          aria-live="polite"
          error={!!error?.message}
          helperText={error?.message}
        />
      )}
    />
  );
}

